// See Velo API Reference
// https://dev.wix.com/docs/velo/articles/api-overview/introduction
// Learn about plugins
// https://dev.wix.com/docs/build-apps/develop-your-app/frameworks/wix-blocks/site-plugins/about-site-plugins-in-blocks
// See list of plugin APIs needed to integrate with plugin slots
// https://dev.wix.com/docs/build-apps/develop-your-app/extensions/site-extensions/site-plugins/supported-wix-app-pages/about-slots
import wixData from 'wix-data';

$w.onReady(function () {
	// Initialize your plugin code here. Make sure that your plugin has the required Plugin API properties to communicate with the plugin slot.  
	$w('#dataset1').setFilter(wixData.filter().hasSome('title', $widget.props.icons))
});

$widget.onPropsChanged((oldProps, newProps) => {
	// Handle changes to plugin property values here.
	$w('#dataset1').setFilter(wixData.filter().hasSome('title', $widget.props.icons))

});
